// Shared constants for the WE Alignment Index assessment.
import {
  Target, MessageSquare, Shield, Users, Zap,
} from 'lucide-react';

// Category icons mapping
export const CATEGORY_ICONS = {
  'Leadership Alignment': Target,
  'Communication Effectiveness': MessageSquare,
  'Role Clarity & Accountability': Shield,
  'Team Dynamics & Trust': Users,
  'Execution & Performance': Zap,
};

// Service recommendation icons mapping
export const SERVICE_ICONS = {
  target: Target,
  'message-square': MessageSquare,
  shield: Shield,
  users: Users,
  zap: Zap,
};

export const CATEGORY_COLORS = {
  'Leadership Alignment': 'from-violet-500 to-purple-600',
  'Communication Effectiveness': 'from-cyan-500 to-blue-600',
  'Role Clarity & Accountability': 'from-amber-500 to-orange-600',
  'Team Dynamics & Trust': 'from-emerald-500 to-teal-600',
  'Execution & Performance': 'from-rose-500 to-pink-600',
};

// 1-5 scale labels for question responses
export const SCALE_LABELS = [
  { value: 1, label: 'Strongly Disagree', color: 'bg-red-500' },
  { value: 2, label: 'Disagree', color: 'bg-orange-500' },
  { value: 3, label: 'Neutral', color: 'bg-amber-500' },
  { value: 4, label: 'Agree', color: 'bg-emerald-500' },
  { value: 5, label: 'Strongly Agree', color: 'bg-cyan-500' },
];
